module.exports = __webpack_public_path__ + "img/ke.c0bf589a.svg";